module.exports = __webpack_public_path__ + "static/media/bar-line.73d7413b.svg";